export default class FlexBoxElement extends HTMLElement {
  constructor() {
    super();
  }

}
customElements.define('flex-box', FlexBoxElement);